import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { LAYER } from 'js/components/common/PopupManager';

import { FreeSpin2BonusGamesPopup } from './FreeSpin2BonusGamesPopup';

/**
 * @param props {Object}
 * @param [props.id] {string}
 * @param [props.title] {string}
 * @param [props.layer] {string}
 * @param [props.gameCodeNames] {string[]}
 * @param [props.controls] {Object}
 * @param [props.selectedBetConfiguration] {Object}
 */
export const showFreeSpin2BonusGamesPopupAction = (props) => {
    return showCommonPopupAction({
        layer: LAYER.HIGH_PRIORITY,
        component: FreeSpin2BonusGamesPopup,
        ...props
    });
};
